import { TextVariants } from "@src/straps/base/type/Text/Text";
import { ProjectTimelineStatus } from "@src/types";
import StatusNode from "./StatusNode";
import { timelineStatusRenderingOptions } from "../projectRenderingOptions";

export default function TimelineStatusNode({
  timelineStatus,
  textVariant,
  hasBackground = false,
}: {
  readonly timelineStatus: ProjectTimelineStatus;
  readonly textVariant?: TextVariants;
  readonly hasBackground?: boolean;
}) {
  const { color, label, backgroundColor } =
    timelineStatusRenderingOptions[timelineStatus];
  return (
    <StatusNode
      title={label}
      icon="dot-closed"
      iconColor={color}
      smallIcon
      textVariant={textVariant}
      bgColor={hasBackground ? backgroundColor : undefined}
      dataTestId="timeline-status-node"
    />
  );
}
